module.exports = __webpack_public_path__ + "img/78eb0a8.png";